import React, { useState, useEffect } from "react";
import Button from "../../../components/Button";
import InputSelect from "../../../components/InputSelect";
import Modal from "../../../components/Modal";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import Input from "../../../components/Input";
import { convertIntToMoney } from "../../../helpers/conversions";
import { canSeeBrands, hasPermission, hasPlanFeature } from "../../../services/auth";

function unmaskCurrencyToInt(value) {
    if (!value) return 0;
  
    const cleaned = value
      .replace(/[R$\s.]/g, '')
      .replace(',', '');
  
    return parseInt(cleaned, 10);
  }

export const ModalFilter = ({showFilter, setShowFilter, setCustomFilters, filters}) => {
    const [customizations, setCustomizations] = useState([]);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [brands, setBrands] = useState([]);

    const [name, setName] = useState(null);
    const [mainSite, setMainSite] = useState(null);
    const [quotable, setQuotable] = useState(null);
    const [sku, setSku] = useState(null);
    const [companySku, setCompanySku] = useState(null);
    const [category, setCategory] = useState(null);
    const [companyId, setCompanyId] = useState(null);
    const [featured, setFeatured] = useState(null);
    const [recent, setRecent] = useState(null);
    const [tagId, setTagId] = useState(null);
    const [image, setImage] = useState(null);
    const [customization, setCustomization] = useState(null);
    const [minPrice, setMinPrice] = useState(null);
    const [maxPrice, setMaxPrice] = useState(null);
    const [minStock, setMinStock] = useState(null);
    const [minQuantity, setMinQuantity] = useState(null);
    const [brandId, setBrandId] = useState(null);

    // Alguns clientes não querem que os vendedores saibam quem são os
    // fornecedores; sem esta permissão o filtro de fornecedor não aparece.
    const canViewProductSupplier = hasPermission('show_product_supplier_in_budget');

    useEffect(() => {
        getCustomizations();
        getCategories();
        getTags();
        getBrands();
        if (canViewProductSupplier) getSuppliers();
    }, []);

    useEffect(() => {
        console.log(category)
    }, [category]);

    useEffect(() => {
        if (!showFilter) return;

        setName(filters.name);
        setMainSite(filters.mainSite);
        setQuotable(filters.quotable);
        setSku(filters.sku);
        setCompanySku(filters.companySku);
        setCategory(filters.category);
        setCompanyId(filters.companyId);
        setFeatured(filters.featured);
        setRecent(filters.recent);
        setTagId(filters.tagId);
        setImage(filters.image);
        setCustomization(filters.customization);
        setMinPrice(filters.minPrice ? convertIntToMoney(filters.minPrice, true) : null);
        setMaxPrice(filters.maxPrice ? convertIntToMoney(filters.maxPrice, true) : null);
        setMinStock(filters.minStock);
        setMinQuantity(filters.minQuantity);
        setBrandId(filters.brandId);
    }, [showFilter, filters]);

    const getCustomizations = () => {
        api.get(`/customization`).then(res => {
            setCustomizations(res.data.resources);
        });
    }

    const getSuppliers = () => {
        api.get(`/company/paginate?&filters[0][type][contain]=product&per_page=9999`).then(res => {
            setSuppliers(res.data.resources.data);
        });
    }

    const getCategories = () => {
        api.get(`/category`).then(res => {
            let toCategories = [];
            res.data.resources.map(category => {
                toCategories.push(category);
                category.categories.map(subcategory => toCategories.push({
                    ...subcategory,
                    name: `${category.name} > ${subcategory.name}`
                }));
            });
            setCategories(toCategories);
        });
    }

    const getBrands = () => {
        if (!canSeeBrands()) return;

        api.get(`/brand?per_page=100`).then(res => {
            setBrands(res.data.resources?.data ?? res.data.resources ?? []);
        }).catch(() => {
            setBrands([]);
        });
    }

    const getTags = () => {
        api.get(`/tag`).then(res => {
            setTags(res.data.resources);
        });
    }

    const isTrue = [
        { label: 'Sim', value: '1' },
        { label: 'Não', value: '0' }
    ];

    const yesNo = [
        { label: 'Sim', value: '1' },
        { label: 'Não', value: '0' }
    ];

    const categoryOptions = [
        { label: 'Todas as categorias', value: null },
        { label: 'Sem categoria', value: 'without_categories' },
        ...createOptions(categories, 'name', 'id'),
    ];    

    const customizationOptions = [
        { label: 'Todas as gravações', value: null },
        { label: 'Sem gravações', value: 'without_customization' },
        ...createOptions(customizations, 'name', 'id'),
    ];        
    
    const handleClear = () => {
        setCustomFilters({
            name: null,
            mainSite: null,
            quotable: null,
            sku: null,
            companySku: null,
            category: null,
            companyId: null,
            featured: null,
            recent: null,
            tagId: null,
            image: null,
            customization: null,
            minPrice: null,
            maxPrice: null,
            minStock: null,
            minQuantity: null,
            brandId: null,
            productId: null,
        });
        setName(null);
        setMainSite(null);
        setQuotable(null);
        setSku(null);
        setCompanySku(null);
        setCategory(null);
        setCompanyId(null);
        setFeatured(null);
        setRecent(null);
        setTagId(null);
        setImage(null);
        setCustomization(null);
        setMinPrice(null);
        setMaxPrice(null);
        setMinStock(null);
        setMinQuantity(null);
        setBrandId(null);
        setShowFilter(false);
    }

    const handleFilter = () => {
        setCustomFilters({
            name,
            mainSite,
            quotable,
            sku,
            companySku,
            category,
            companyId,
            featured,
            recent,
            tagId,
            image,
            customization,
            minPrice: minPrice && unmaskCurrencyToInt(minPrice) !== 0 ? unmaskCurrencyToInt(minPrice) : null,
            maxPrice: maxPrice ? unmaskCurrencyToInt(maxPrice) : null,
            minStock,
            minQuantity,
            brandId,
            productId: null,
        });
        setShowFilter(false);
    }
    
    return (
        <Modal
            show={showFilter}
            close={() => setShowFilter(false)}
            title={`Filtrar`}
            footer={
                <>
                    <Button
                        type={`secondary`}
                        size={`small`}
                        text={`Limpar filtros`}
                        action={handleClear}
                    />
                    <Button
                        type={`primary`}
                        size={`small`}
                        text={`Filtrar resultados`}
                        action={handleFilter}
                    />
                    
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <Input 
                            label={`Nome`}
                            value={name}
                            change={setName}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input 
                            label={`SKU`}
                            value={sku}
                            change={setSku}
                        />
                    </div>
                    <div className="col-6">
                        <Input 
                            label={`SKU do fornecedor`}
                            value={companySku}
                            change={setCompanySku}
                        />                        
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect label={`Site principal`} options={yesNo} value={mainSite} change={setMainSite} />
                    </div>
                    <div className="col-6">
                        <InputSelect label={`Categoria`} 
                            options={categoryOptions} 
                            value={
                                category === 'without_categories'
                                ? 'without_categories'
                                : category === null
                                ? null
                                : category
                            } 
                            getOptionLabel={option =>
                                option.value === 'without_categories' 
                                ? 'Sem categoria' 
                                : option.value === null 
                                ? 'Todas as categorias' 
                                : option.label
                            }
                            change={setCategory} 
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect label={`Orçamentos pelo sistema`} options={yesNo} value={quotable} change={setQuotable} />
                    </div>
                </div>               
                <div className="row">
                    <div className="col-4">
                        <InputSelect label={`Destaque`} 
                            options={isTrue} 
                            value={featured} 
                            change={setFeatured} 
                        />
                    </div>
                    <div className="col-4">
                        <InputSelect label={`Novidade`} 
                            options={isTrue} 
                            value={recent} 
                            change={setRecent}
                        />                        
                    </div>
                    <div className="col-4">
                        <InputSelect label={`Tag`} 
                            options={createOptions(tags, 'text', 'id', true)} 
                            value={tagId} 
                            change={setTagId} 
                        />
                    </div>
                </div>               
                <div className="row">
                    <div className="col">
                    <InputSelect 
                        label={`Gravação`} 
                        options={customizationOptions} 
                        value={
                            customization === 'without_customization'
                            ? 'without_customization'
                            : customization === null
                            ? null
                            : customization
                        } 
                        change={setCustomization} 
                        getOptionLabel={option =>
                            option.value === 'without_customization'
                            ? 'Sem gravação'
                            : option.value === null
                            ? 'Todas as gravações'
                            : option.label
                        }
                    />
                    </div>
                </div> 
                {brands.length > 0 &&
                    <div className="row">
                        <div className="col">
                            <InputSelect
                                label={`Marca`}
                                options={createOptions(brands, 'name', 'id', true, null, 'Todas as marcas')}
                                value={brandId}
                                change={setBrandId}
                            />
                        </div>
                    </div>
                }
                {canViewProductSupplier &&
                    <div className="row">
                        <div className="col">
                            <InputSelect label={`Fornecedor`}
                                options={createOptions(suppliers, 'trade_name', 'id', true)}
                                value={companyId}
                                change={setCompanyId}
                            />
                        </div>
                    </div>
                }
                {hasPermission('show_product_supplier_price_in_budget') && hasPlanFeature('calculation') &&
                    <div className="row">
                        <div className="col-6">
                            <Input
                                label={`Preço a partir de`}
                                value={minPrice}
                                change={setMinPrice}
                                mask={'convertToMoney'}
                            />
                        </div>
                        <div className="col-6">
                            <Input
                                label={`Preço até`}
                                value={maxPrice}
                                change={setMaxPrice}
                                mask={'convertToMoney'}
                            />
                        </div>
                    </div> 
                }
                <div className="row">
                    {hasPlanFeature('stock') &&
                        <div className="col-6">
                            <Input
                                label={`Estoque mínimo`}
                                value={minStock}
                                change={setMinStock}
                                mask={'convertToInt'}
                            />
                        </div>
                    }
                    <div className={hasPlanFeature('stock') ? "col-6" : "col"}>
                        <Input
                            label={`Quantidade mínima a partir de`}
                            value={minQuantity}
                            change={setMinQuantity}
                            mask={'convertToInt'}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
